const getFieldSelector = (name) => `[name="${name}"], [name$="/${name}"]`;
const dispatchFieldEvents = (input) => {
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
};
const setHubspotFieldValue = (form, name, value, formInstance) => {
    var _a, _b;
    try {
        void Promise.resolve((_a = formInstance === null || formInstance === void 0 ? void 0 : formInstance.setFieldValue) === null || _a === void 0 ? void 0 : _a.call(formInstance, name, value)).catch(() => undefined);
    }
    catch (error) {
        void error;
    }
    try {
        (_b = form.setFieldValue) === null || _b === void 0 ? void 0 : _b.call(form, name, value);
    }
    catch (error) {
        void error;
    }
};
const syncRenderedInput = (form, name, value) => {
    const input = form.querySelector(getFieldSelector(name));
    if (!input) {
        return false;
    }
    input.value = value;
    dispatchFieldEvents(input);
    return true;
};
const appendHiddenInput = (form, name, value) => {
    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.name = name;
    hiddenInput.value = value;
    form.appendChild(hiddenInput);
};
export const syncHubspotFields = ({ fields, form, formInstance, }) => {
    Object.entries(fields).forEach(([name, value]) => {
        const resolvedValue = value !== null && value !== void 0 ? value : '';
        setHubspotFieldValue(form, name, resolvedValue, formInstance);
        if (syncRenderedInput(form, name, resolvedValue)) {
            return;
        }
        appendHiddenInput(form, name, resolvedValue);
    });
};
